import { Grid, useTheme } from '@mui/material';
import Typography from '@mui/material/Typography';
import { get as _get } from 'lodash';
import { useState } from 'react';
import { FREEFORM_REGEX } from '../../../utils/Regex-Util';
import { RegexTextField } from '../RegexTextField/RegexTextField';

export default function FreeformText(props: any) {
  const [count, setCount] = useState(props.initialValue ? props.initialValue.length : 0);
  const theme = useTheme();

  const charCount = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const comment = _get(event, 'target.value', '');
    setCount(comment.length);
    props.textUpdate(comment);
  };

  return (
    <Grid container>
      <Grid sx={{ marginTop: '0px' }} item xs={12}>
        <Typography sx={theme.custom.styles.formLabelStyle}>{props.subcase}</Typography>
      </Grid>
      <Grid item xs={12}>
        <RegexTextField
          sx={{
            width: '100%',
            height: 'auto',
            marginTop: '0px',
            '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
              height: 'inherit',
            },
            '& .MuiInputBase-root': {
              height: 'inherit',
            },
          }}
          margin="dense"
          variant="outlined"
          multiline={true}
          rows={5}
          defaultValue={props.initialValue}
          inputProps={{
            maxLength: 500,
          }}
          regex={FREEFORM_REGEX}
          changeHandler={charCount}
        />
      </Grid>
      <Grid
        sx={{
          marginTop: '0px',
          display: 'flex',
          flexDirection: 'row-reverse',
        }}
        item
        xs={12}
      >
        <Typography sx={theme.custom.styles.formLabelStyle}>{count}/500</Typography>
      </Grid>
    </Grid>
  );
}
